export default {
  scheduled_order: 'Comandă programată',
  show_more: 'Arată mai mult',
  show_less: 'Arată mai puțin',
  schedule_order: 'Programați comanda',
};
